import gql from 'graphql-tag';
import {useQuery} from 'react-apollo';

import * as Generated from '../../generated/graphql';

///// Query definition

export const SINGLE_FILE_QUERY = gql`
  query SingleFile(
    $projectName: String!
    $entityName: String
    $runName: String!
    $fileName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      run(name: $runName) {
        id
        files(first: 1, names: [$fileName]) {
          edges {
            node {
              id
              name
              directUrl
              sizeBytes
              updatedAt
            }
          }
        }
      }
    }
  }
`;

export interface Files {
  edges: Array<{
    node: {
      id: string;
      name: string;
      directUrl: string;
      sizeBytes: number;
      updatedAt: string;
    };
  }>;
}

// The query's output shape.
interface Data {
  project: {
    run: {
      files: Files;
    };
  };
}

export function useSingleFileQuery(
  variables: Generated.SingleFileQueryVariables
) {
  const query = useQuery<Data, typeof variables>(SINGLE_FILE_QUERY, {
    variables,
    fetchPolicy: 'no-cache',
  });
  const fileEdges = query.data?.project.run.files.edges || [];
  return {
    // eslint-disable-next-line @typescript-eslint/prefer-as-const
    loading: query.loading,
    file: fileEdges.length === 0 ? undefined : fileEdges[0].node,
  };
}
